import { PostAttachment, Video, YoutubeUrlParser } from "@authory-packages/core";
import dynamic from "next/dynamic";
import { YoutubeVideoWrapper } from "./VideoViewer.styles";
import { VerticalSpacing } from "../VerticalSpacing";
import { V3VideoPlayer } from "../VideoPlayer/V3VideoPlayer";
import { V3ArticleView } from "../ReusableStyledComponents/V3ArticleView";
import { nofollowLinks } from "../../utils/nofollowLinks";

const YouTube = dynamic(() => import("react-youtube"), { ssr: false });

type VideoViewerProps = {
    video: Video;
    showHTML?: boolean;
};

export const VideoViewer = ({ video, showHTML = true }: VideoViewerProps) => {
    const isYoutube = video.originalSourceUrl && YoutubeUrlParser.isYoutubeVideoUrl(video.originalSourceUrl);
    const parsed = video.originalSourceUrl && YoutubeUrlParser.parseYoutubeUrl(video.originalSourceUrl);
    const canPlayVideo = video.videoUrl && !video.videoUrl.endsWith(".m3u8");

    return (
        <>
            {!isYoutube && canPlayVideo && video.videoUrl && (
                <YoutubeVideoWrapper>
                    <V3VideoPlayer
                        attachment={{
                            type: PostAttachment.video,
                            videoUrl: video.videoUrl,
                            thumbnailUrl: video.previewImageUrl,
                            contentType: video.contentType
                        }}
                    />
                </YoutubeVideoWrapper>
            )}
            {isYoutube && canPlayVideo && parsed && (
                <YoutubeVideoWrapper>
                    <YouTube
                        videoId={parsed?.id}
                        onError={() => {}}
                        opts={{
                            width: "100%"
                        }}
                    />
                </YoutubeVideoWrapper>
            )}
            {showHTML && (
                <VerticalSpacing top={48}>
                    <V3ArticleView dangerouslySetInnerHTML={{ __html: nofollowLinks(video.html) }} suppressHydrationWarning />
                </VerticalSpacing>
            )}
        </>
    );
};
